// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { render } from 'react-dom'
import { browserHistory } from 'react-router'

import Routes from './routes';

import './index.css';
window.userType = 0;

render(
  <Routes history={browserHistory} />,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/